/* eslint-disable no-console */
import { isKnownExperiment, isKnownVariant } from './experiments';
import type { ExperimentAssignment } from './types';

/**
 * Maps the wire assignment list to Map<experimentName, variantCode>, dropping
 * (with a dev warning) entries whose experiment/variant the registry doesn't
 * know or that miss required fields. Dropped → absent → useExperiment returns
 * 'control' and no exposure fires.
 */
export function toAssignmentMap(
  raw: readonly ExperimentAssignment[] | undefined
): Map<string, string> {
  const map = new Map<string, string>();
  for (const a of raw ?? []) {
    // swaggie emits experimentName / assignedVariantCode as optional — guard undefined.
    if (!a.experimentName || !isKnownExperiment(a.experimentName)) {
      console.warn(`[experiments] unknown experiment "${a.experimentName}" in payload — skipped`);
      continue;
    }
    if (!a.assignedVariantCode || !isKnownVariant(a.experimentName, a.assignedVariantCode)) {
      console.warn(
        `[experiments] unknown variant "${a.assignedVariantCode}" for "${a.experimentName}" — treating as control`
      );
      continue;
    }
    map.set(a.experimentName, a.assignedVariantCode);
  }
  return map;
}
